export const reset_wizard = (idElement) =>{
    $(`#${idElement}`).wizard('destroy');
}


export const init_wizard = (
        orderId=0,
        userFunc,
        monto=0,
        idElement,
        container
    ) => {
    /*const picker = datepicker('#fecha_transferencia', {
        customMonths: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        customDays: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
        formatter: (input, date, instance) => {
            const value = date.toLocaleDateString()
            input.value = value // => '1/1/2099'
        },
        onSelect: (instance, date) => {
            // Do stuff when a date is selected (or unselected) on the calendar.
            // You have access to the datepicker instance for convenience.
        },
        dateSelected: new Date(),
        position: 'tl'
    });
    const picker_seguro = datepicker('#fecha_transferencia_seguro', {
        customMonths: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        customDays: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
        formatter: (input, date, instance) => {
            const value = date.toLocaleDateString()
            input.value = value // => '1/1/2099'
        },
        dateSelected: new Date(),
        position: 'tl'
    });*/

    $.mask.definitions['*'] = '[A-Z-a-z]';
    $.mask.definitions['°'] = '0-9';
    /*$("#rif_transferencia").mask("*99999999", {placeholder: "X-XXXXXXXX"});
    $("#rif_transferencia_seguro").mask("*99999999", {placeholder: "X-XXXXXXXX"});*/
    /*$("#celular_transferencia").mask("(0999)-999-9999", {placeholder: "(XXXX)-XXX-XXXX"});
    $("#celular_transferencia_seguro").mask("(0999)-999-9999", {placeholder: "(XXXX)-XXX-XXXX"});*/

    //console.info(idElement);
        //$('.wizard').attr('id', idElement);
    if (idElement === 'step_uno') {
        $.ajax({
            url: '/api/pagos/entities',
            contentType: "application/json",
            type: "POST",
            dataType: 'json',
            data: JSON.stringify({
                "token": "_adQssw5c"
            })

        }).then(function (dataAjax) {
            const resp = $.map(dataAjax.data, function (obj) {
                obj.id = obj.entity_ID; // replace pk with your identifier
                obj.text = obj.entity_code + " - " + obj.entity_name; // replace pk with your identifier
                return obj;
            });

            $('#banco_transferencia').select2({
                language: "es",
                theme: "classic",
                width: '100%',
                data: resp,
                placeholder: "Selecciona banco",
            });
            $('#banco_transferencia').val(3).trigger('change');

        });
        $("#monto").remove();
        $('.monto_transferencia').append(`<span id="monto"> Total: ${monto} </span>`);
    }else{
        $.ajax({
            url: '/api/pagos/entities',
            contentType: "application/json",
            type: "POST",
            dataType: 'json',
            data: JSON.stringify({
                "token": "_adQssw5c"
            })

        }).then(function (dataAjax) {
            const resp = $.map(dataAjax.data, function (obj) {
                obj.id = obj.entity_ID; // replace pk with your identifier
                obj.text = obj.entity_code + " - " + obj.entity_name; // replace pk with your identifier
                return obj;
            });

            $('#banco_transferencia_seguro').select2({
                language: "es",
                theme: "classic",
                width: '100%',
                data: resp,
                placeholder: "Selecciona banco",
            });
            $('#banco_transferencia_seguro').val(3).trigger('change');
            $("#monto_seguro").remove();
            $('.monto_transferencia_seguro').append(`<span id="monto_seguro"> Total: ${monto} </span>`);
        });
    }

    let finish =false;
        $(`#${idElement}`).wizard({
            buttonLabels: {
                next: 'Siguiente',
                back: 'Atrás',
                finish: 'Finalizar'
            },
            enableWhenVisited: true,
            onInit: function() {
                $('.wizard-steps li').on('click', function (ev) {
                    //$(this).removeAttr('data-target');
                    ev.stopPropagation();
                });
                if(idElement === 'step_uno') {

                    $('#validation_terminales').formValidation({
                        framework: 'bootstrap',
                        fields: {
                            rif_transferencia: {
                                validators: {
                                    notEmpty: {
                                        message: 'La cédula o RIF es obligatorio'
                                    },
                                    regexp: {
                                        regexp: /^[V|E|J|P|v|e|j|p][0-9]{5,9}$/,
                                        message: 'Ingrese cédula o RIF válido V0000000 (Inicia con V,E,J,P)'
                                    },
                                }
                            },
                            celular_transferencia: {
                                validators: {
                                    notEmpty: {
                                        message: 'Ingrese número de contacto'
                                    },
                                    regexp: {
                                        regexp: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/,
                                        message: 'Ingrese número de contacto válido'
                                    },

                                }
                            },
                            referencia_transferencia: {
                                validators: {
                                    notEmpty: {
                                        message: 'La referencia bancaria es obligatoria'
                                    },
                                    digits: {
                                        message: 'Ingrese los dígitos de la referencia'
                                    },
                                    stringLength: {
                                        min: 5,
                                        max: 16,
                                        message: 'Ingrese dígitos de entre 6 y/o 15 carácteres'
                                    },
                                    remote: {
                                        url: '/api/pagos/referencia',
                                        // Send { username: 'its value', email: 'its value' } to the back-end
                                        data: function () {
                                            return {
                                                ref:$('#referencia_transferencia').val(),
                                                token: "_adQssw5c"
                                            };
                                        },
                                        message: 'La referencia ya se encuentra en uso',
                                        type: 'POST',
                                    },
                                }
                            },'banco_transferencia[]': {
                                validators: {
                                    notEmpty: {
                                        message: 'Ingrese el banco de emisión'
                                    }
                                }
                            },'fecha_transferencia': {
                                validators: {
                                    notEmpty: {
                                        message: 'La fecha de transferencia es obligatoria'
                                    },
                                    regexp: {
                                        regexp: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
                                        message: 'Ingrese una fecha válida'
                                    },
                                }
                            },'soporte_transferencia': {
                                validators: {
                                    notEmpty: {
                                        message: 'Debe adjuntar soporte de la transferencia'
                                    },
                                    file: {
                                        extension: 'pdf',
                                        type: 'application/pdf',
                                        maxSize: 4000000,
                                        message: 'El soporte de pago debe ser en formato PDF no mayor a 4MB'
                                    },
                                }
                            }
                        }
                    });
                }else {
                    $('#validation_seguro').formValidation({
                        framework: 'bootstrap',
                        fields: {
                            rif_transferencia: {
                                validators: {
                                    notEmpty: {
                                        message: 'La cédula o RIF es obligatorio'
                                    },
                                    regexp: {
                                        regexp: /^[V|E|J|P|v|e|j|p][0-9]{5,9}$/,
                                        message: 'Ingrese cédula o RIF válido V0000000 (Inicia con V,E,J,P)'
                                    },
                                }
                            },
                            celular_transferencia: {
                                validators: {
                                    notEmpty: {
                                        message: 'Ingrese número de contacto'
                                    },
                                    regexp: {
                                        regexp: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/,
                                        message: 'Ingrese número de contacto válido'
                                    },

                                }
                            },
                            referencia_transferencia: {
                                validators: {
                                    notEmpty: {
                                        message: 'La referencia bancaria es obligatorio'
                                    },
                                    digits: {
                                        message: 'Ingrese los digitos de la referencia'
                                    },
                                    stringLength: {
                                        min: 5,
                                        max: 15,
                                        message: 'Ingrese digitos de entre 6 y/o 15 carácteres'
                                    },
                                    // different: {
                                    //     compare: function () {
                                    //         return $('#referencia_transferencia').val();
                                    //     },
                                    //     message: 'La referencia ya fue registrada',
                                    // },
                                    remote: {
                                        url: '/api/pagos/referencia',
                                        // Send { username: 'its value', email: 'its value' } to the back-end
                                        data: function () {
                                            return {
                                                ref:$('#referencia_transferencia_seguro').val(),
                                                token: "_adQssw5c"
                                            };
                                        },
                                        message: 'La referencia ya se encuentra en uso',
                                        type: 'POST',
                                    },

                                }
                            }, 'banco_transferencia_seguro[]': {
                                validators: {
                                    notEmpty: {
                                        message: 'El banco de emisión es obligatorio'
                                    }
                                }
                            },'soporte_transferencia_seguro': {
                                validators: {
                                    notEmpty: {
                                        message: 'Debe adjuntar soporte de la transferencia'
                                    },
                                    file: {
                                        extension: 'pdf',
                                        type: 'application/pdf',
                                        maxSize: 4000000,
                                        message: 'El soporte de pago debe ser en formato PDF no mayor a 4MB'
                                    },
                                }
                            },'fecha_transferencia_seguro': {
                                validators: {
                                    notEmpty: {
                                        message: 'La fecha de transferencia es obligatoria'
                                    },
                                    regexp: {
                                        regexp: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
                                        message: 'Ingrese una fecha válida'
                                    },
                                }
                            }
                        }
                    });
                }
            },
            validator: function() {
                var $this = $(this);
                if(idElement === 'step_uno') {
                    var fv_uno = $('#validation_terminales').data('formValidation');
                    fv_uno.validateContainer($this);
                    var isValidStep_uno = fv_uno.isValidContainer($this);
                    if (isValidStep_uno === false || isValidStep_uno === null) {
                        return false;
                    }
                }
                if(idElement === 'step_dos') {
                    var fv_dos = $('#validation_seguro').data('formValidation');
                    fv_dos.validateContainer($this);
                    var isValidStep_dos = fv_dos.isValidContainer($this);
                    if (isValidStep_dos === false || isValidStep_dos === null) {
                        return false;
                    }
                }
                return true;
            },
            onFinish: function() {
                //if(finish===true)

                $(`.${container}`).modal('toggle');
                //$('.wizard').attr('id', '');
                //$('#exampleTarget').wizard('destroy');
                /*return userFunc({
                    data: true
                });*/
                //location.reload();
            },
            onBeforeShow: function(step) {
                if(step.index === 2){
                    $('.wizard-back').hide();
                    $('.close').hide();
                    $('.wizard-finish').hide();
                    //$('.wizard-finish').show();
                    $( ".wizard-buttons" ).append( '<span class="soporte_pago_transferencia"><i class="fas fa-spinner fa-spin"></i> Subiendo soporte de pago</span>' );


                }
                //console.log($('#banco_transferencia').select2('data')[0].entity_ID);

            },
             onReset: function() {
                 $('.wizard-back').show();
                 $('.close').show();
             },
            onNext: function(from, to) {

                if(from.index ===1){
                    var form = (idElement === 'step_uno')?document.getElementById("validation_terminales"):
                        document.getElementById("validation_seguro");
                    var formData = new FormData(form);
                    formData.append("referencia", ((idElement === 'step_uno')?
                        $('#referencia_transferencia').val():
                        $('#referencia_transferencia_seguro').val()))
                    formData.append("rif_pago", ((idElement === 'step_uno')?
                        $('#rif_transferencia').val():
                        $('#rif_transferencia_seguro').val()));
                    formData.append("celular_pago", ((idElement === 'step_uno')?
                        $('#celular_transferencia').val():
                        $('#celular_transferencia_seguro').val()))
                    formData.append("banco_pago", ((idElement === 'step_uno')?
                        $('#banco_transferencia').select2('data')[0].entity_ID:
                        $('#banco_transferencia_seguro').select2('data')[0].entity_ID))
                    formData.append("estatus_order", 5)
                    formData.append("order", orderId)
                    formData.append("metodo_pago", "TRANSFERENCIA")
                    $.ajax({
                        url: '/api/pagos/callback/cdn',
                        type: "POST",
                        cache: false,
                        contentType: false,
                        processData: false,
                        method: 'POST',
                        data: formData,
                        error: function(XMLHttpRequest, textStatus, errorThrown) {
                            console.log("TRANSFERENCIA Status: " + textStatus); console.log("Error: " + errorThrown);
                        }
                    }).then( function (formResp) {
                        $('.wizard-finish').show();
                        $('.soporte_pago_transferencia').remove();
                        //$(`.${container}`).modal('toggle');
                        return userFunc({
                            data: true
                        });

                        //
                        //finish=true;
                    });
                    /*console.info('Submit');
                    console.info(orderId);
                    if(idElement === 'step_uno') {
                        console.info($('#rif_transferencia').val());
                        console.info($('#celular_transferencia').val());
                        console.info($('#referencia_transferencia').val());
                        console.info($('#banco_transferencia').val());
                    }
                    if(idElement === 'step_dos') {
                        console.info($('#rif_transferencia_seguro').val());
                        console.info($('#celular_transferencia_seguro').val());
                        console.info($('#referencia_transferencia_seguro').val());
                        console.info($('#banco_transferencia_seguro').val());
                    }*/


                }
            },
        });

    }


